import { CategoryMapper } from './category.mapper';
import { AnswerMapper } from './answer.mapper';
import { ComplexQuestion } from './complex-question.model';
import { SimpleQuestionMapper } from './simple-question.mapper';

export class ComplexQuestionMapper {
  public static map(simpleQuestionData: any): ComplexQuestion {
    if (!simpleQuestionData) {
      return null;
    }

    return new ComplexQuestion (
        simpleQuestionData.id,
        simpleQuestionData.type,
        simpleQuestionData.order,
        simpleQuestionData.comment,
        simpleQuestionData.questions.map(SimpleQuestionMapper.map),
        simpleQuestionData.categoryVisible
      );
    }
}



// WEBPACK FOOTER //
// /dist/src/app/question/complex-question.mapper.ts